import { gql } from '@apollo/client';

export const FORGOTTEN_PASSWORD = gql`
  mutation FORGOTTEN_PASSWORD($email: String!, $recaptchaToken: String!) {
    forgottenPassword(email: $email, recaptchaToken: $recaptchaToken)
  }
`;
